import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'quibbl',
  templateUrl: './quibbl.component.html',
  styleUrls: ['./quibbl.component.scss']
})
export class QuibblComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/quibbl/quibbl.component.ts